import styled from "styled-components";

export const StyledCardTitleLogoContainer = styled.div`
    margin-right: 8px;
    &:empty {
        margin-right: 0;
    }
`;

export default StyledCardTitleLogoContainer;
